import type { Entity } from '@backstage/catalog-model';
import { isTemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';

const titleCase = (category: string): string => {
  return category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const categoryLabels: Record<string, string> = {
  website: 'Applications',
  repo: 'Repositories',
  devcontainer: 'Development containers',
  'repo-health': 'Repository health',
};

export const getCategoryLabel = (category: string): string => {
  if (categoryLabels[category]) {
    return categoryLabels[category];
  }
  return titleCase(category);
};

/**
 * Extracts the set of unique, lowercased `spec.type` values from the given
 * entities, restricted to the categories defined in `categoryDisplayNames`.
 * Non-template entities and unknown types are skipped.
 */
export const getCategories = (entities: Entity[]): string[] => {
  const categories = new Set<string>();
  for (const entity of entities) {
    if (!isTemplateEntityV1beta3(entity)) {
      continue;
    }
    categories.add(entity.spec.type.toLowerCase());
  }
  return Array.from(categories);
};
